import React, { ComponentProps } from "react";

export default function PencilIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      {...props}
    >
      <path
        d="M9.51178 0.989746C9.29855 0.989746 9.0853 1.07118 8.92259 1.23389L7.91672 2.23975L10.0001 4.32308L11.0059 3.31722C11.3314 2.9918 11.3314 2.46425 11.0059 2.13883L10.101 1.23389C9.93827 1.07118 9.72501 0.989746 9.51178 0.989746ZM7.08338 3.07308L2.19158 7.96484C2.19158 7.96484 2.57398 7.93058 2.71648 8.07308C2.85898 8.21558 2.74168 9.14808 2.91668 9.32308C3.09168 9.49808 4.01831 9.3749 4.15123 9.50781C4.28414 9.64073 4.27493 10.0482 4.27493 10.0482L9.16673 5.15641L7.08338 3.07308ZM1.66667 9.32308L1.2736 10.4364C1.25815 10.4803 1.25017 10.5265 1.25 10.5731C1.25 10.6836 1.2939 10.7896 1.37204 10.8677C1.45018 10.9458 1.55616 10.9897 1.66667 10.9897C1.71324 10.9896 1.75946 10.9816 1.80339 10.9661C1.80475 10.9656 1.80611 10.9651 1.80746 10.9645L1.81804 10.9613C1.81885 10.9607 1.81967 10.9602 1.82048 10.9596L2.91668 10.5731L2.29167 9.94808L1.66667 9.32308Z"
        fill="#7E43FF"
      />
      <path
        d="M9.51178 0.989746C9.29855 0.989746 9.0853 1.07118 8.92259 1.23389L7.91672 2.23975L10.0001 4.32308L11.0059 3.31722C11.3314 2.9918 11.3314 2.46425 11.0059 2.13883L10.101 1.23389C9.93827 1.07118 9.72501 0.989746 9.51178 0.989746ZM7.08338 3.07308L2.19158 7.96484C2.19158 7.96484 2.57398 7.93058 2.71648 8.07308C2.85898 8.21558 2.74168 9.14808 2.91668 9.32308C3.09168 9.49808 4.01831 9.3749 4.15123 9.50781C4.28414 9.64073 4.27493 10.0482 4.27493 10.0482L9.16673 5.15641L7.08338 3.07308ZM1.66667 9.32308L1.2736 10.4364C1.25815 10.4803 1.25017 10.5265 1.25 10.5731C1.25 10.6836 1.2939 10.7896 1.37204 10.8677C1.45018 10.9458 1.55616 10.9897 1.66667 10.9897C1.71324 10.9896 1.75946 10.9816 1.80339 10.9661C1.80475 10.9656 1.80611 10.9651 1.80746 10.9645L1.81804 10.9613C1.81885 10.9607 1.81967 10.9602 1.82048 10.9596L2.91668 10.5731L2.29167 9.94808L1.66667 9.32308Z"
        fill="url(#paint0_linear_468_11276)"
        fillOpacity="0.16"
      />
      <defs>
        <linearGradient
          id="paint0_linear_468_11276"
          x1="6.25"
          y1="0.989746"
          x2="6.25"
          y2="10.9897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
